<template>
    <div class="right-container">
        <p class="right-h2">关于字体</p>
        <p class="right-content">在切图的过程中会遇到需要设置字体的地方，不过字体不能随意设置，因为有些字体要买版权才能使用，所以在切图的过程中要留意一下。</p>
        <p class="right-content">以下是鸿蒙的字体，鸿蒙的字体是免费的，可以随意使用。</p>
        <p class="right-content hm-black">Black</p>
        <p class="right-content hm-bold">Bold</p>
        <p class="right-content hm-medium">Medium</p>
        <p class="right-content hm-regular">Regular</p>
        <p class="right-content hm-light">Light</p>
        <p class="right-content hm-thin">Thin</p>
        <p class="right-content"><a download href="/file/HarmonyOS_Sans_SC.zip">字体下载</a></p>
    </div>
</template>

<script>
export default {
    name: 'font'
}
</script>

<style lang="scss" scoped>

</style>